import * as React from 'react';
import styled from 'styled-components';
import { colors } from '@omilia/theme';

const SButton = styled.button`
  background: none;
  align-items: center;
  border: 1px solid ${colors.COLOR_BLUE_600};
  border-radius: 5px;
  color: ${colors.COLOR_BLUE_600};
  display: inline-flex;
  font-size: 14px;
  height: 36px;
  padding: 0 14px;
  text-align: center;

  img {
    border-radius: 50%;
    margin-left: 0;
    margin-right: 8px;
    width: 20px;
  }

  &:hover {
    background-color: ${colors.COLOR_BLUE_400};
    cursor: pointer;
  }
`;

interface IButton {
  label: string;
  iconName?: string;
  onClick: (any) => void;
}

const Button: React.FC<IButton> = ({ label, iconName, onClick }) => (
  <SButton onClick={onClick} data-test="button">
    {iconName && <img src={require(`assets/icons/${iconName}`)} alt="icon" />}
    <span>{label}</span>
  </SButton>
);

export default Button;
